import { Badge } from '@/components/ui/badge';
import { AlertTriangle, Clock, CheckCircle, XCircle } from 'lucide-react';

interface CancellationStatusBadgeProps {
  status: string;
  size?: 'sm' | 'default' | 'lg';
}

export const CancellationStatusBadge = ({ status, size = 'default' }: CancellationStatusBadgeProps) => {
  const getStatusConfig = (status: string) => {
    switch (status) {
      case 'pending_vendor_response':
        return {
          variant: 'secondary' as const,
          label: 'Awaiting Vendor Response',
          icon: Clock,
          color: 'text-yellow-600',
        };
      case 'pending_client_approval':
        return {
          variant: 'secondary' as const,
          label: 'Awaiting Client Decision',
          icon: Clock,
          color: 'text-blue-600',
        };
      case 'client_accepted':
        return {
          variant: 'default' as const,
          label: 'Cancellation Approved',
          icon: CheckCircle,
          color: 'text-green-600',
        };
      case 'disputed':
        return {
          variant: 'destructive' as const,
          label: 'Under Dispute',
          icon: XCircle,
          color: 'text-destructive',
        };
      case 'completed':
        return {
          variant: 'default' as const,
          label: 'Cancelled',
          icon: CheckCircle,
          color: 'text-green-600',
        };
      default:
        return {
          variant: 'secondary' as const,
          label: status,
          icon: AlertTriangle,
          color: 'text-muted-foreground',
        };
    }
  };

  const config = getStatusConfig(status);
  const Icon = config.icon;
  const iconSize = size === 'sm' ? 'h-3 w-3' : size === 'lg' ? 'h-5 w-5' : 'h-4 w-4';

  return (
    <Badge variant={config.variant} className="gap-1">
      <Icon className={`${iconSize} ${config.color}`} />
      {config.label}
    </Badge>
  );
};
